<template>
  <div class="main-menu-desktop">
    <AsideMenuLogo route="prime" />
    <AsideMenuSkeleton :is-loading="!isUserDataReady">
      <AsideMenu :routes="routes" />
    </AsideMenuSkeleton>
  </div>
</template>

<script>
import AsideMenu from './aside-menu';
import AsideMenuLogo from './aside-menu-logo';
import AsideMenuSkeleton from './aside-menu-skeleton';

export default {
  props: {
    isUserDataReady: {
      type: Boolean,
      required: true,
    },
    routes: {
      type: Array,
      default: () => [],
    },
  },
  components: { AsideMenuSkeleton, AsideMenu, AsideMenuLogo }
};
</script>
